// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hotel-platform {
  display: grid;
  position: absolute;
  grid-template-rows: repeat(4, 6.1vw);
  gap: 0.25vw;
  width: 7.3vw;
  bottom: 12.5%;
}

.hotel-windowimg {
  position: absolute;
  width: 100%;
  height: 100%;
}

.hotel-character {
  position: relative;
}
.hotel-characterimg {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 85%;
}

.hotel-a {
  left: 34.75%;
}
.hotel-b {
  left: 48%;
}
.hotel-c {
  left: 60.94%;
}
.hotel-d {
  left: 74%;
}
.hotel-e {
  left: 87.3%;
  width: 4.86vw;
}
.hotel-selectedRoom {
  outline: 0.2vw solid #0ce626;
  outline-offset: -0.2vw;
}
.hotel-selectedErrorRoom{
  outline: 0.2vw solid #ff3700;
  outline-offset: -0.2vw;
}
.hotel-blindsWrapper {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.hotel-blinds {
  position: absolute;
  inset: 0;
  z-index: 2;
  transform: translateY(0);
}

.hotel-blinds.open {
  animation: blindsOpen 2s ease-out forwards;
}

.hotel-e .hotel-4 {
  clip-path: polygon(0 0, 40% 0, 100% 28%, 100% 100%, 0 100%);
}

@keyframes blindsOpen {
  0% {
    transform: translateY(0);
  }

  60% {
    transform: translateY(-30%);
  }

  100% {
    transform: translateY(-120%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Stevehotel/styles/HotelRenderPlatform.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".hotel-platform {\n  display: grid;\n  position: absolute;\n  grid-template-rows: repeat(4, 6.1vw);\n  gap: 0.25vw;\n  width: 7.3vw;\n  bottom: 12.5%;\n}\n\n.hotel-windowimg {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.hotel-character {\n  position: relative;\n}\n.hotel-characterimg {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 85%;\n}\n\n.hotel-a {\n  left: 34.75%;\n}\n.hotel-b {\n  left: 48%;\n}\n.hotel-c {\n  left: 60.94%;\n}\n.hotel-d {\n  left: 74%;\n}\n.hotel-e {\n  left: 87.3%;\n  width: 4.86vw;\n}\n.hotel-selectedRoom {\n  outline: 0.2vw solid #0ce626;\n  outline-offset: -0.2vw;\n}\n.hotel-selectedErrorRoom{\n  outline: 0.2vw solid #ff3700;\n  outline-offset: -0.2vw;\n}\n.hotel-blindsWrapper {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n}\n\n.hotel-blinds {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  transform: translateY(0);\n}\n\n.hotel-blinds.open {\n  animation: blindsOpen 2s ease-out forwards;\n}\n\n.hotel-e .hotel-4 {\n  clip-path: polygon(0 0, 40% 0, 100% 28%, 100% 100%, 0 100%);\n}\n\n@keyframes blindsOpen {\n  0% {\n    transform: translateY(0);\n  }\n\n  60% {\n    transform: translateY(-30%);\n  }\n\n  100% {\n    transform: translateY(-120%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
